import { Component, ContentChild, HostBinding, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'unh-slot-left',
  template: `<ng-content></ng-content>`
})
export class SlotLeftComponent {}

@Component({
  selector: 'unh-slot-middle',
  template: `<ng-content></ng-content>`
})
export class SlotMiddleComponent {}

@Component({
  selector: 'unh-slot-right',
  template: `<ng-content></ng-content>`
})
export class SlotRightComponent {}


@Component({
  selector: 'unh-generic-content-container',
  templateUrl: './generic-content-container.component.html',
  styleUrls: ['./generic-content-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenericContentContainerComponent {
  @ContentChild(SlotLeftComponent) slotLeft: SlotLeftComponent;
  @ContentChild(SlotMiddleComponent) slotMiddle: SlotMiddleComponent;
  @ContentChild(SlotRightComponent) slotRight: SlotRightComponent;

  // @Input()
  // set direction(dir: 'row' | 'column') {
  //   this.portrait = dir === 'column';
  // }

  // @HostBinding('class.portrait') portrait = false;
}
